import { TSOBarcodeMode } from '../../../enums/TSOBarcodeMode';

export class GenerateTSOReportInput {
    orderIds: number[];
    barcodeMode?: TSOBarcodeMode;
}